import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReferralLinkManager = ({ referralLink, clickAnalytics }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard?.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareOptions = [
    { name: 'WhatsApp', icon: 'MessageCircle', color: 'bg-green-500', url: `https://wa.me/?text=${encodeURIComponent(referralLink)}` },
    { name: 'Facebook', icon: 'Facebook', color: 'bg-blue-600', url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}` },
    { name: 'TikTok', icon: 'Music', color: 'bg-black', url: `https://www.tiktok.com/` },
    { name: 'Instagram', icon: 'Instagram', color: 'bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500', url: `https://www.instagram.com/` }
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-6 border border-border">
      <h2 className="text-2xl font-bold text-foreground mb-6">Gestión de Enlaces de Referido</h2>
      <div className="bg-gradient-to-r from-primary/10 to-secondary/10 p-6 rounded-lg mb-6 border border-primary/20">
        <label className="block text-sm font-semibold text-foreground mb-3">Tu Enlace de Referido</label>
        <div className="flex gap-3">
          <div className="flex-1 bg-card px-4 py-3 rounded-lg border border-border text-foreground font-mono text-sm break-all">
            {referralLink}
          </div>
          <Button
            variant={copied ? 'success' : 'default'}
            onClick={handleCopyLink}
            iconName={copied ? 'Check' : 'Copy'}
            iconPosition="left"
            className="whitespace-nowrap"
          >
            {copied ? 'Copiado' : 'Copiar'}
          </Button>
        </div>
      </div>
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Compartir en Redes Sociales</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {shareOptions?.map((option) => (
            <a
              key={option?.name}
              href={option?.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${option?.color} text-white p-4 rounded-lg hover:opacity-90 transition-all flex flex-col items-center justify-center gap-2 min-h-[100px]`}
            >
              <Icon name={option?.icon} size={28} color="white" />
              <span className="text-sm font-medium">{option?.name}</span>
            </a>
          ))}
        </div>
      </div>
      <div className="bg-muted/30 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="BarChart2" size={20} />
          Análisis de Clics
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-card p-4 rounded-lg border border-border">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-muted-foreground">Total de Clics</span>
              <Icon name="MousePointer" size={18} className="text-primary" />
            </div>
            <div className="text-2xl font-bold text-foreground">{clickAnalytics?.totalClicks}</div>
            <div className="text-xs text-success mt-1">+{clickAnalytics?.clicksThisWeek} esta semana</div>
          </div>

          <div className="bg-card p-4 rounded-lg border border-border">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-muted-foreground">Conversiones</span>
              <Icon name="UserCheck" size={18} className="text-success" />
            </div>
            <div className="text-2xl font-bold text-foreground">{clickAnalytics?.conversions}</div>
            <div className="text-xs text-muted-foreground mt-1">{clickAnalytics?.conversionRate}% tasa</div>
          </div>

          <div className="bg-card p-4 rounded-lg border border-border">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-muted-foreground">Clics Únicos</span>
              <Icon name="Users" size={18} className="text-secondary" />
            </div>
            <div className="text-2xl font-bold text-foreground">{clickAnalytics?.uniqueClicks}</div>
            <div className="text-xs text-muted-foreground mt-1">{clickAnalytics?.uniqueRate}% únicos</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralLinkManager;